<template>
    <b-modal id="imgViewModal" :title="title" size="md">
        <div style="text-align:center;">
            <img v-if="fileId" :src="'/file/getImgFile/' + fileId" alt="" style="max-width:100%; max-height:600px;">
            <p v-else>등록된 이미지가 없습니다.</p>
        </div>
        <template #modal-footer="{ ok }">
            <b-button class="btn btn_md btn_brown" @click="ok()">닫기</b-button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        name: 'imgViewModal',
        props: {
            title: String,
            fileId: [String, Number],
        }
    }
</script>
